import { render, staticRenderFns } from "./AutorizacionViatico.vue?vue&type=template&id=1fc83c8e"
import script from "./AutorizacionViatico.vue?vue&type=script&lang=js"
export * from "./AutorizacionViatico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports